import React, { Component } from 'react'

export default class CardFlex extends Component {
    render() {
    const { cards, className } = this.props;

        return (
            <div className={`card_flex_container ${className}`}>
                {cards}
             </div>
        )
    }
}
